module.exports = __webpack_public_path__ + "img/berserk.50fb84eb.svg";